import { showMessage } from "../components/Common/Toaster"
import { get } from "lodash"
import moment from "moment"
import { createBrowserHistory } from "history"
const history = createBrowserHistory()
export default history

export function storeTokenToLocalStorage(token) {
  if (token) {
    localStorage.setItem("token", token)
  }
}

export function storeUserToLocalStorage(user) {
  localStorage.setItem("user", JSON.stringify(user))
}

export function getTokenFromLocalStorage() {
  return localStorage.getItem("token")
}

export function deleteTokenFromLocalStorage() {
  localStorage.removeItem("token")
}
export function capitalizeFirstLetter(str) {
  var splitStr = str?.toLowerCase().split(" ")
  for (var i = 0; i < splitStr?.length; i++) {
    // You do not need to check if i is larger than splitStr length, as your for does that for you
    // Assign it back to the array
    splitStr[i] =
      splitStr[i]?.charAt(0)?.toUpperCase() + splitStr[i]?.substring(1)
  }
  // Directly return the joined string
  return splitStr?.join(" ")
}

export const mapApiArrayData = data => {
  if (data.length == 0) return []
  let lb = ""
  data = data.map(item => {
    lb = capitalizeFirstLetter(item.name.replace(/-/g, " "))
    return {
      value: item.id,
      label: lb,
    }
  })
  return data
}
export const addSlashestoApiNames = name =>
  name.toLowerCase().replace(/ /g, "-")
export const getCurrentUser = name => {
  let str = name.replace(/-/g, " ")
  str = str.split("=").pop()
  str = toUpper(str)
  return str
}
export function toUpper(str) {
  return str
    .toLowerCase()
    .split(" ")
    .map(function (word) {
      return word[0] ? word[0].toUpperCase() + word.substr(1) : ""
    })
    .join(" ")
}
export const getCurrentUserFromApi = name => {
  let str = name.split("=").pop()
  return str
}
export const apiErrorsArray = errorsArray => {
  if (![undefined, null, ""].includes(errorsArray.message)) {
    return errorsArray.message[0]
  }
  return []
}
export const mapApiSlashesData = data => {}

export const showErrorMessages = error => {
  error?.response?.data?.error &&
    showMessage("error", error?.response?.data?.error)
  error?.response?.data?.message &&
    showMessage("error", error?.response?.data?.message)
  if (error?.response?.data?.errors) {
    let errorsObj = error.response.data.errors
    for (var key of Object.keys(errorsObj)) {
      console.log(key + " -> " + errorsObj[key])
      errorsObj[key].forEach(arr => {
        showMessage("error", arr)
      })
    }
  }
}

export const checkIfSuperAdmin = () => {
  let data = JSON.parse(localStorage.getItem("user"))
  let roles = data?.user?.roles
  let superadmin = roles?.filter(role => {
    return role.name === "super-admin" ? true : false
  })
  if (superadmin && superadmin.length > 0) {
    return true
  }
  return false
}

export const getUrlLastPart = () => {
  let url = new URL(window.location.href)
  if (url["search"] == "") {
    return url["pathname"].split("/").filter(Boolean).pop()
  }
  return url["search"].split("=").pop()
}
export const getActiveClass = userLabel => {
  let lastPart = getUrlLastPart()
  if (userLabel == lastPart) return "mm-active"
  return ""
}

export function dynamicSort(property) {
  var sortOrder = 1
  if (property[0] === "-") {
    sortOrder = -1
    property = property.substr(1)
  }
  return function (a, b) {
    /* next line works with strings and numbers,
     * and you may want to customize it to your needs
     */
    var result =
      a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0
    return result * sortOrder
  }
}
export const mapDataForDropDown = data => {
  if (data?.length == 0) return []
  data = data?.map(item => {
    return {
      value: item.id,
      label: item.name,
      id: item.id,
    }
  })
  return data
}
export const mapCashierDataForDropDown = data => {
  if (data?.length == 0) return []
  data = data?.map(item => {
    return {
      value: item.id,
      label: item.username,
      id: item.id,
    }
  })
  return data
}

export const mapImageForPreview = data => {
  if (data?.length == 0) return []
  data = data?.map(item => {
    return {
      ...item,
      preview: URL.createObjectURL(item),
      formattedSize: formatBytes(item?.size),
    }
  })
  return data
}
export function formatBytes(bytes, decimals = 2) {
  if (bytes === 0) return "0 Bytes"
  const k = 1024
  const dm = decimals < 0 ? 0 : decimals
  const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]

  const i = Math.floor(Math.log(bytes) / Math.log(k))
  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i]
}

export const getInitialStateForUpdate = (type, data, urlId) => {
  let obj = data.filter(op => op["id"] == urlId)
  obj = obj.length > 0 ? obj[0] : {}
  return obj[type]
}

export const hasPermission = (key = "") => {
  const permissions = get(
    JSON.parse(localStorage.getItem("user"))?.user?.roles[0],
    "permissions",
    []
  )
  return permissions.some(p => p.name === key)
}
export const checkUserHasRole = (key = "") => {
  const roles = get(JSON.parse(localStorage.getItem("user"))?.user, "roles", [])
  return roles.some(p => p.name === key)
}

export const lastSevenDays = () => {
  let days = []
  for (let i = 1; i <= 7; i++) {
    let day = moment().add(i, "days")
    days.push(day.format("dddd"))
  }
  return days
}

export const convertToDateTimeString = date => {
  const format = "DD/MM/YYYY HH:mm:ss"
  return moment(date).format(format)
}

export function numberWithCommas(number) {
  return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
}
export const groupSimilarConsecutiveItems = percentages => {
  let currentUser
  let groupedMessages = []

  for (const selection of percentages) {
    if (selection.value !== currentUser) {
      groupedMessages.push([])
      currentUser = selection.value
    }
    return groupedMessages[groupedMessages.length - 1].push(selection)
  }
}

var arrayWithDuplicates = [
  { type: "LICENSE", licenseNum: "12345", state: "NV" },
  { type: "LICENSE", licenseNum: "A7846", state: "CA" },
  { type: "LICENSE", licenseNum: "12345", state: "OR" },
  { type: "LICENSE", licenseNum: "10849", state: "CA" },
  { type: "LICENSE", licenseNum: "B7037", state: "WA" },
  { type: "LICENSE", licenseNum: "12345", state: "NM" },
]

export function removeDuplicates(originalArray, prop) {
  var newArray = []
  var lookupObject = {}

  for (var i in originalArray) {
    lookupObject[originalArray[i][prop]] = originalArray[i]
  }

  for (i in lookupObject) {
    newArray.push(lookupObject[i])
  }
  return newArray
}
export function stripHTML(html) {
  let doc = new DOMParser().parseFromString(html, "text/html")
  return doc.body.textContent || ""
}

export const dateIsBetween = (compareDate, startDate, endDate) => {
  if ([undefined, null, ""].includes(endDate)) return
  compareDate = moment(compareDate, "YYYY-MM-DD")
  startDate = moment(startDate, "YYYY-MM-DD")
  endDate = moment(endDate, "YYYY-MM-DD")

  return compareDate.isBetween(startDate, endDate, undefined, []) //false in this case
}

export const removeFileExtension = fileName =>
  fileName.split(".").slice(0, -1).join(".")
